import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

const STATUS_STYLE = {
  paid: "bg-[#A78BFA]/10 text-[#A78BFA]",
  created: "bg-white/5 text-zinc-400",
  failed: "bg-red-500/10 text-red-400",
};

export default function Payments() {
  const [payments, setPayments] = useState(null);

  useEffect(() => {
    api.get("/admin/payments").then((r) => setPayments(r.data)).catch(() => setPayments([]));
  }, []);

  const paidTotal = payments?.filter((p) => p.status === "paid").reduce((s, p) => s + p.amount, 0) || 0;

  return (
    <div data-testid="admin-payments-page">
      <div className="flex items-end justify-between mb-8">
        <div>
          <h1 className="font-['Outfit'] font-extrabold tracking-tight text-3xl mb-2">Payments</h1>
          <p className="text-zinc-500 text-sm">Everyone who paid — full payment history.</p>
        </div>
        <div className="text-right" data-testid="payments-total">
          <span className="text-zinc-500 text-xs">Total Collected</span>
          <p className="font-['Outfit'] font-extrabold text-2xl text-[#A78BFA]">₹{paidTotal.toLocaleString("en-IN")}</p>
        </div>
      </div>
      <div className="bg-[#0a0a0a] border border-white/10 rounded-2xl overflow-x-auto">
        <Table data-testid="payments-table" className="min-w-[720px]">
          <TableHeader>
            <TableRow className="border-white/10 hover:bg-transparent">
              <TableHead className="text-zinc-400">Name</TableHead>
              <TableHead className="text-zinc-400">Phone</TableHead>
              <TableHead className="text-zinc-400">Amount</TableHead>
              <TableHead className="text-zinc-400">Mode</TableHead>
              <TableHead className="text-zinc-400">Status</TableHead>
              <TableHead className="text-zinc-400">Date</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {payments?.map((p) => (
              <TableRow key={p.order_id} className="border-white/5 hover:bg-white/5" data-testid={`payment-row-${p.order_id}`}>
                <TableCell className="text-white">{p.name}</TableCell>
                <TableCell className="text-zinc-400">{p.phone}</TableCell>
                <TableCell className="text-white font-medium">₹{p.amount}</TableCell>
                <TableCell className="text-zinc-500 text-xs uppercase">{p.mode}</TableCell>
                <TableCell>
                  <span className={`text-xs px-2.5 py-1 rounded-full ${STATUS_STYLE[p.status] || STATUS_STYLE.created}`} data-testid={`payment-status-${p.order_id}`}>
                    {p.status}
                  </span>
                </TableCell>
                <TableCell className="text-zinc-500 text-xs">{new Date(p.created_at).toLocaleString("en-IN")}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        {payments && payments.length === 0 && <p className="text-zinc-500 text-sm p-8 text-center" data-testid="payments-empty">No payments yet.</p>}
      </div>
    </div>
  );
}
